/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Header_Back_To_ChatInputs */

const es_admin_header_back_to_chat = /** @type {(inputs: Admin_Header_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al chat`)
};

const en_admin_header_back_to_chat = /** @type {(inputs: Admin_Header_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to chat`)
};

/**
* | output |
* | --- |
* | "Back to chat" |
*
* @param {Admin_Header_Back_To_ChatInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_header_back_to_chat = /** @type {((inputs?: Admin_Header_Back_To_ChatInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Header_Back_To_ChatInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_header_back_to_chat(inputs)
	return en_admin_header_back_to_chat(inputs)
});
export { admin_header_back_to_chat as "admin.header.back_to_chat" }